import HttpClient, { IResponseModel } from "../HttpClient";

const ConvertImageService = {
  convertPngtoPct: async (
    imageBase64: string,
  ): Promise<IResponseModel<string>> => {
    const client = new HttpClient();
    return await client.request<string>({
      method: "POST",
      url: `misc/convertPngToPctHandler`,
      data: imageBase64,
    });
  },
};

export default ConvertImageService;
